// src/components/ReserveInitializer.tsx
import { useEffect } from 'react';
import { useReserveContext } from '../contexts/useReserveContext';
import { fetchCurrentCustomerSession } from '../utils/auth/customerSession';
import { saveCustomerAuthToken } from '../utils/auth/customerAuthToken';

const ReserveInitializer = () => {
  const { setCustomerId } = useReserveContext();

  useEffect(() => {
    let active = true;

    const syncCustomer = async () => {
      try {
        const session = await fetchCurrentCustomerSession();
        if (!active) return;
        saveCustomerAuthToken(session.auth_token);
        setCustomerId(session.customer_id);
      } catch (error) {
        if (!active) return;
        console.error('ReserveInitializer failed to load session:', error);
        setCustomerId(null);
      }
    };

    void syncCustomer();

    return () => {
      active = false;
    };
  }, [setCustomerId]);

  return null;
};

export default ReserveInitializer;
